var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoosterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13217 23.2501C6.00651 23.2502 5.88235 23.2228 5.76841 23.1698C5.65448 23.1168 5.55353 23.0394 5.47267 22.9433C5.39181 22.8471 5.33299 22.7343 5.30035 22.613C5.26771 22.4916 5.26203 22.3646 5.28373 22.2408V22.2357L6.60139 15.0001H1.49998C1.35838 15.0001 1.21968 14.96 1.09992 14.8844C0.980153 14.8089 0.884224 14.7009 0.823224 14.5732C0.762224 14.4454 0.738644 14.3029 0.755214 14.1623C0.771784 14.0217 0.827825 13.8886 0.916856 13.7785L11.1905 1.07819C11.3074 0.92975 11.4697 0.823695 11.6526 0.776244C11.8356 0.728794 12.029 0.742559 12.2033 0.815437C12.3777 0.888314 12.5234 1.01629 12.6181 1.1798C12.7129 1.34331 12.7514 1.53334 12.7279 1.72085C12.728 1.73491 12.7242 1.7485 12.7219 1.76257L11.3995 9.00007H16.5C16.6416 9.00008 16.7803 9.04018 16.9 9.11573C17.0198 9.19128 17.1157 9.29918 17.1767 9.42697C17.2377 9.55476 17.2613 9.6972 17.2447 9.83783C17.2282 9.97846 17.1721 10.1115 17.0831 10.2216L6.80811 22.9219C6.72737 23.024 6.62466 23.1064 6.50763 23.1632C6.3906 23.2201 6.26226 23.2497 6.13217 23.2501Z",
    fill: "#F9DA87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoosterLogo);
export default __webpack_public_path__ + "static/media/boosterLogo.8b5740bf4ffeac0a2862504e2d37a519.svg";
export { ForwardRef as ReactComponent };